import { useState } from 'react';
import ChangePassword from '../Common/ChangePassword/Index';

const Modal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="relative w-full max-w-[510px] rounded-lg bg-white dark:bg-navy-800">
        <button
          onClick={onClose}
          className=" absolute right-2 top-2 h-10 w-8 rounded-full text-3xl text-brand-900 transition duration-200 dark:text-brand-900 dark:text-navy-200"
          aria-label="Close"
        >
          &times;
        </button>

        <div className="p-2">
          <ChangePassword />
        </div>
      </div>
    </div>
  );
};

const PasswordChangeModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      <button
        onClick={openModal}
        className="rounded-xl bg-brand-500 px-8 py-2 text-base font-medium text-white transition duration-200 hover:cursor-pointer hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
      >
        Update Password
      </button>

      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default PasswordChangeModal;
